import { render } from "./AboutMe.vue?vue&type=template&id=e3025922&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"

import "./AboutMe.vue?vue&type=style&index=0&id=e3025922&scoped=true&lang=scss"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3025922"]])

export default __exports__